import { Component, EventEmitter, Input, Output } from '@angular/core'
import { Plan, PlanResponse } from '../../../services/plans.service'
import { CommonModule } from '@angular/common'
import { incomingSubscription, PlanView, SubscriptionStatus } from '../../../services/subscriptions'
import dayjs from 'dayjs'

@Component({
  selector: 'app-plan-card',
  imports: [CommonModule],
  templateUrl: './plan-card.component.html',
  styleUrl: './plan-card.component.scss'
})
export class PlanCardComponent {
  @Input({ required: true }) plan!: PlanView
  @Input({ required: true }) isCurrentPlan!: boolean
  @Input({ required: true }) currentPlan!: incomingSubscription | null
  @Output() planSelected = new EventEmitter<PlanView>()
  SubscriptionStatus = SubscriptionStatus

  onGetStarted(): void {
    this.planSelected.emit(this.plan)
  }

  showGetStarted(): boolean {
    if (!this.currentPlan) return false

    const status = this.currentPlan.subscriptionStatus
    const expiry = this.currentPlan.expiryDate ? dayjs(this.currentPlan.expiryDate) : null

    const now = dayjs()
    return (
      status === SubscriptionStatus.Trialing ||
      status === SubscriptionStatus.Expired ||
      (status === SubscriptionStatus.Active && !!expiry && expiry.isAfter(now))
    )
  }
}
